import {
  TripLegStatus,
  TripLegStatusBC,
} from '../data/models/trip-leg-status.model';

/*
 * Checks if a given status matches the canceled statuses
 */
function isCanceledStatus(status: TripLegStatus): boolean {
  return [TripLegStatus.Canceled, TripLegStatus.CanceledLate].includes(status);
}

/*
 * Checks if a given status matches the finalized statuses
 */
function isFinalizedStatus(status: TripLegStatus): boolean {
  return [
    TripLegStatus.Completed,
    TripLegStatus.NoLoad,
    TripLegStatus.CanceledLate,
  ].includes(status);
}

/*
 * Checks if a given status matches the in progress statuses
 */
function isInProgressStatus(status: TripLegStatus): boolean {
  return [
    TripLegStatus.InTransit,
    TripLegStatus.Onsite,
    TripLegStatus.Onboard,
  ].includes(status);
}

export { isCanceledStatus, isFinalizedStatus, isInProgressStatus };
